import { Injectable } from '@angular/core';
import { ISession } from '../data/session.interface';

export interface IAuditLogEntry {
  userId: string;
  userName: string;
  role: string;
  email: string;
  timestamp: string;
  action: 'disclaimer_accepted';
}

const AUDIT_LOG_KEY = 'audit_log_attendance_reports';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {
  logDisclaimerAccepted(session: ISession): void {
    const entry: IAuditLogEntry = {
      userId: session.sid,
      userName: session.name,
      role: session.role,
      email: session.emailaddress,
      timestamp: new Date().toISOString(),
      action: 'disclaimer_accepted'
    };

    const logs = this.getAuditLog();
    logs.push(entry);
    localStorage.setItem(AUDIT_LOG_KEY, JSON.stringify(logs));
  }

  getAuditLog(): IAuditLogEntry[] {
    const raw = localStorage.getItem(AUDIT_LOG_KEY);
    if (!raw) return [];
    try {
      return JSON.parse(raw) as IAuditLogEntry[];
    } catch {
      return [];
    }
  }

  clearAuditLog(): void {
    localStorage.removeItem(AUDIT_LOG_KEY);
  }
}
